'use client';

import type { StoreApi, UseBoundStore } from 'zustand';
import type { FixtureEntry } from '@/components/launchpad/use-proposal-fixtures';
import { createTrackedStore } from '@/lib/dev/zustand-registry';

/**
 * Dev-only store: when fixture mode is active and a user clicks a fixture row,
 * we stash the fixture data here so the detail page can render it instead of
 * hitting the API (which would 404 for fake pubkeys).
 */

interface FixtureDetailStore {
  entry: FixtureEntry | null;
  set: (entry: FixtureEntry) => void;
  clear: () => void;
}

export const useFixtureDetailStore: UseBoundStore<StoreApi<FixtureDetailStore>> =
  createTrackedStore<FixtureDetailStore>('useFixtureDetailStore')((set) => ({
    entry: null,
    set: (entry: FixtureEntry): void => set({ entry }),
    clear: (): void => set({ entry: null }),
  }));
